<ti-form-field-container
  [formGroup]="formGroup"
  [name]="config.fieldName"
  [label]="config.fieldTitle"
  [labelPosition]="config.UIData?.isWide || config.UIData?.searchMode ? 'left' : 'top'"
  [hideLabel]="config.UIData?.hideLabel">
  <div class="general-room-options">
    @if (isEventActive) {
      <ti-checkbox
        [title]="strings.enableEventManager"
        [value]="setValueObj.enableEventManagement"
        (valueChange)="eventChange($event)"></ti-checkbox>
    }
    @if (isLMSActive) {
      <ti-checkbox
        [title]="strings.enableLMSIntegration"
        [value]="setValueObj.LMSValue"
        (valueChange)="LMSChange($event)"></ti-checkbox>
    }
    <ng-container>
      <ti-checkbox
        [title]="strings.enableCommunication"
        [value]="setValueObj.enableCommunication"
        (valueChange)="communicationChange($event)"></ti-checkbox>
    </ng-container>
    @if (setValueObj.enableCommunication) {
      <ti-checkbox
        [title]="strings.enableOutbox"
        [value]="setValueObj.outboxValue"
        (valueChange)="outboxChange($event)"></ti-checkbox>
    }
    @if (isCTMSActive) {
      <ti-checkbox
        [title]="strings.enableCTMSIntegration"
        [value]="setValueObj.CTMSValue"
        [infoHint]="strings.externalCTMSHint"
        (valueChange)="CTMSChange($event)"></ti-checkbox>
    }
    <ti-checkbox
      [title]="strings.doNotGenerateDefaultFolderLabel"
      [value]="setValueObj.doNotGenerateDefaultFolder"
      (valueChange)="doNotGenerateDefaultFolderChange($event)"></ti-checkbox>
    <ti-checkbox
      [title]="strings.enableESignature"
      [value]="setValueObj.eSignatureOn"
      [disabled]="esignatureDisabled"
      [infoHint]="!esignatureDisabled && isMultitenantInstance ? strings.eSignatureHint : undefined"
      (valueChange)="eSignatureChange($event)"></ti-checkbox>
    @if (setValueObj.eSignatureOn) {
      <ti-form-field-container [label]="strings.esignatureType" [required]="true" labelPosition="top">
        <kendo-dropdownlist
          tiKendoDropDownTooltip
          class="esignature-types"
          [title]="strings.esignatureType"
          [data]="esignaturesData"
          textField="name"
          valueField="id"
          [valuePrimitive]="true"
          [value]="setValueObj.eSignatureTypeId"
          (selectionChange)="eSignatureValueChange($event)"
          [disabled]="esignatureDisabled">
        </kendo-dropdownlist>
      </ti-form-field-container>
    }
    <ti-checkbox
      [title]="strings.useForCloning"
      [value]="setValueObj.useForCloning"
      (valueChange)="useForCloningChange($event)"></ti-checkbox>
    @if (setValueObj.useForCloning) {
      <ti-form-field-container [label]="strings.cloningCategory" labelPosition="top">
        <div class="cloning-category-wrapper">
          <kendo-dropdownlist
            tiKendoDropDownTooltip
            class="cloning-category-dropdown"
            [title]="strings.cloningCategory"
            [data]="cloningCategoryData"
            textField="topicName"
            valueField="topicId"
            [valuePrimitive]="true"
            [value]="setValueObj.cloningCategoryId"
            [loading]="cloningCategoryLoading"
            (selectionChange)="cloningCategoryChange($event)"
            [disabled]="!cloningCategoryData">
          </kendo-dropdownlist>
          <button
            kendoButton
            fillMode="outline"
            themeColor="tertiary"
            iconClass="fa-solid fa-plus"
            (click)="addNewCategory()"
            [disabled]="!cloningCategoryData"></button>
        </div>
      </ti-form-field-container>
    }

    @if (cloneInvSitesAvailable) {
      <ti-checkbox
        [title]="strings.cloneInvestigativeSites"
        [value]="setValueObj.enableCloneInvSites"
        (valueChange)="enableCloneInvSitesChange($event)"></ti-checkbox>
      @if (setValueObj.enableCloneInvSites) {
        <ti-form-field-container [label]="strings.sourceRoom" labelPosition="top">
          <kendo-dropdownlist
            #sourceRoomDropdown
            tiKendoDropDownTooltip
            class="source-room-dropdown"
            [title]="strings.sourceRoom"
            [data]="sourceRoomData"
            textField="topicName"
            valueField="siteId"
            [valuePrimitive]="true"
            [value]="setValueObj.cloneInvSitesFromSiteId"
            [loading]="sourceRoomsLoading"
            (selectionChange)="sourceRoomChange($event)"
            [filterable]="sourceRoomAll.length > 10"
            (filterChange)="filterSourceRooms($event)"
            [disabled]="!setValueObj.enableCloneInvSites || sourceRoomsLoading">
          </kendo-dropdownlist>
        </ti-form-field-container>
        <ti-form-field-container
          [label]="strings.whatShouldBeTheStatusOfTheSitesInTheRoom"
          [required]="true"
          labelPosition="top"
          [errors]="getStatusError() ? [getStatusError()] : []">
          <ti-radio-group
            [name]="'retainInvSiteStatus'"
            [mode]="'row'"
            [(ngModel)]="setValueObj.retainInvSiteStatus"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="changeRetainInvSiteStatus()"
            [data]="retainStatusOptions" />
        </ti-form-field-container>
      }
    }
  </div>
</ti-form-field-container>
